import { render, staticRenderFns } from "./UsersRoleSelector.vue?vue&type=template&id=d5646018&"
import script from "./UsersRoleSelector.vue?vue&type=script&lang=js&"
export * from "./UsersRoleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports